import { TableCell, TableRow, Skeleton } from '@mui/material';
import { getStyled } from './styles';

const TableRowSkeleton = ({ avatar, columns }) => {
  const classes = getStyled();
  return (
    <>
      <TableRow>
        {avatar && (
          <>
            <TableCell sx={{ paddingRight: 0 }}>
              <Skeleton
                animation='wave'
                variant='circle'
                width={40}
                height={40}
              />
            </TableCell>
            <TableCell>
              <Skeleton animation='wave' height={30} width={80} />
            </TableCell>
          </>
        )}
        {Array.from({ length: columns }, (_, index) => (
          <TableCell align='center' key={index}>
            <div style={classes.customTableCell}>
              <Skeleton
                align='center'
                animation='wave'
                height={30}
                width={80}
              />
            </div>
          </TableCell>
        ))}
      </TableRow>
    </>
  );
};

export default TableRowSkeleton;
